import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import get from 'lodash/get';
import { pending, rejected } from 'redux-saga-thunk';
import { notification } from 'antd';
import moment from 'moment';
import ForecastList from '../../components/pages/ForecastList/index';
import { resourceListReadRequest } from '../../store/resource/actions';
import { fromEntities, fromResource } from '../../store/selectors';
import { modalShow } from '../../store/modal/actions';
import ForecastAdd from './ForecastAdd';

class ForecastListContainer extends Component {
  columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (text, record) => (
        <a
          onClick={e => {
            e.preventDefault();
            this.props.history.push(`/forecasts/${record.id}/revision/${record.revision_id}`);
          }}
          href={`/forecasts/${record.id}/revision/${record.revision_id}`}
        >
          {text}
        </a>
      ),
    },
    {
      title: 'Start Date',
      dataIndex: 'start_date',
      render: text => this.formatDate(text),
    },
    {
      title: 'End Date',
      dataIndex: 'end_date',
      render: text => this.formatDate(text),
    },
    {
      title: 'inStore',
      dataIndex: 'instore_daily_impressions',
      render: (t, r) => Math.ceil(t * r.instore_adj_factor).toLocaleString(),
    },
    {
      title: 'inHand',
      dataIndex: 'inhand_daily_impressions',
      render: (t, r) =>
        Math.ceil(
          t * r.inhand_adj_factor * r.inhand_product_count * r.ease_of_scan
        ).toLocaleString(),
    },
    {
      title: 'inPath',
      dataIndex: 'custom_inpath_preceptivity_daily_impressions',
      render: (t, r) =>
        Math.ceil(
          r.preceptivity_daily_impressions *
            r.instore_adj_factor *
            r.avg_ad_request_per_device *
            r.inpath_pct_of_requests
        ).toLocaleString(),
    },
    {
      title: 'Preceptivity',
      dataIndex: 'preceptivity_daily_impressions',
      render: (t, r) =>
        Math.ceil(t * r.preceptivity_adj_factor * r.avg_ad_request_per_device).toLocaleString(),
    },
    {
      title: 'Revisions',
      dataIndex: 'revisions',
      render: r => r && r.toLocaleString(),
    },
    {
      title: 'Creator',
      dataIndex: 'author',
    },
    {
      title: 'Creation date',
      dataIndex: 'creation_date',
      render: text => this.formatDate(text),
    },
  ];

  static defaultProps = {
    forecast: [],
  };

  state = {
    pagination: { current: 1, pageSize: 10, total: 0 },
    tableState: {
      sortField: null,
      sortOrder: null,
      searchTerm: null,
    },
  };

  componentDidMount() {
    this.fetchTableData();
  }

  fetchTableData = () => {
    this.props
      .getForecastList({
        ...this.state.pagination,
        ...this.state.tableState,
      })
      .then(() =>
        this.setState({
          pagination: { ...this.state.pagination, total: this.props.forecastCount },
        })
      )
      .catch(e => {
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not retrieve forecast.',
          duration: 0,
        });
      });
  };

  formatDate = dateStr => {
    if (dateStr) {
      return moment(dateStr).format('MM/DD/YYYY');
    }
    return '';
  };

  handleSearchTable(searchTerm) {
    // Clear sorting, pagination and search.
    const { pageSize } = this.state.tableState;
    this.setState(
      {
        tableState: {
          sortField: null,
          sortOrder: null,
          page: 0,
          pageSize,
          searchTerm,
        },
      },
      () => {
        this.fetchTableData();
      }
    );
  }

  handleTableChange = (pagination, filters, sorter) => {
    const pager = {
      ...this.state.pagination,
      current: pagination.current,
      total: this.props.forecastCount,
    };

    // Update state and fetch table data, pagination and sorter.  Filters are handled by search.
    const updateTableState = this.state.tableState;

    updateTableState.filteredInfo = filters;

    if (sorter) {
      updateTableState.sortField = sorter.columnKey;
      updateTableState.sortOrder = sorter.order;
    }

    this.setState({ pagination: pager, tableState: updateTableState }, () => {
      this.fetchTableData();
    });
  };

  render() {
    return [
      <ForecastAdd key={1} />,
      <ForecastList
        key={2}
        pagination={this.state.pagination}
        columns={this.columns}
        handleTableChange={this.handleTableChange}
        handleSearchTable={searchTerm => {
          this.handleSearchTable(searchTerm);
        }}
        {...this.props}
      />,
    ];
  }
}

const mapStateToProps = state => ({
  loading: pending(state, 'forecastListRead'),
  rejectedForecast: rejected(state, 'forecastDetailRead'),
  forecastList: fromEntities.getList(state, 'forecast', fromResource.getList(state, 'forecast')),
  forecastCount: get(state, 'resource.forecast.count', 0),
});

const mapDispatchToProps = dispatch => ({
  showNewForecastModal: () => dispatch(modalShow('add-forecast')),
  getForecastList: ({ searchTerm, current, pageSize, archived }) =>
    dispatch(
      resourceListReadRequest('forecast', {
        q: searchTerm,
        page_num: current,
        page_size: pageSize,
        archived: !archived ? undefined : true,
      })
    ),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ForecastListContainer);
